import { z } from 'zod';
import { productionModuleSchema } from './productionModuleSchema';
import { ClientId } from '../ClientId';
import { NavigationGroups } from '../NavigationGroups';
import { salesModuleSchema } from './salesModuleSchema';
import { warehouseModuleSchema } from './warehouseModuleSchema';
import { workersAndCompetenciesModuleSchema } from './workersAndCompetenciesModuleSchema';
import { globalModuleSchema } from './globalModuleSchema';

export const configSchema = z.object({
  clientId: z.nativeEnum(ClientId),
  navigationOrder: z.array(z.nativeEnum(NavigationGroups)),
  env: z.enum(['local', 'test', 'stage', '']).default(''),
  isNotification: z.boolean().default(false),
  isCountLimit: z.boolean().default(true),
  countLimit: z.number().default(99),
  countOptionsFetchForSelect: z.number().default(30),
  minDeadlineDays: z.number().default(4),
  minWarningDeadlineDays: z.number().default(8),
  salesVatRate: z.number().default(0.23),
  defaultRecipe: z.number().default(2),
  recipeType: z.number().default(2),
  defaultCurrency: z.string().default('PLN'),
  dateFormats: z
    .object({
      withoutHours: z.string().default('d.MM.yyyy'),
      withHours: z.string().default('d.MM.yyyy, HH:mm'),
    })
    .default({}),
  modules: z.object({
    global: globalModuleSchema,
    production: productionModuleSchema,
    sales: salesModuleSchema,
    warehouse: warehouseModuleSchema,
    workersAndCompetences: workersAndCompetenciesModuleSchema,
  }),
});

export type ConfigSchema = z.infer<typeof configSchema>;
export type ConfigSchemaInput = z.input<typeof configSchema>;
